import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "exception-handling"
    }}>{`Exception handling`}</h1>
    <p>{`The WebApi module has an implementation to "mask" `}<inlineCode parentName="p">{`LocalizedExceptions`}</inlineCode>{` so they aren't exposed to the client. GraphQL accomplishes this by restricting verbose output to only those exceptions implementing `}<inlineCode parentName="p">{`\\GraphQL\\Error\\ClientAware`}</inlineCode>{`, and only if the system is in developer mode. In these circumstances, the application returns a full stack trace. Otherwise, the application writes these exceptions to the system `}<inlineCode parentName="p">{`exception.log`}</inlineCode>{` file while returning an "internal server error" to the client.`}</p>
    <p>{`You should implement the `}<inlineCode parentName="p">{`\\GraphQL\\Error\\ClientAware`}</inlineCode>{` interface to handle errors in your module that are directly related to a GraphQL field having an anticipated exception. If you don't, the client will not receive useful messages. However, you should ensure that you don't implement the `}<inlineCode parentName="p">{`ClientAware`}</inlineCode>{` interface for too many exceptions. Doing this risks exposing sensitive data to the client.`}</p>
    <p>{`Adobe Commerce and Magento Open Source provide the following exception classes in `}<inlineCode parentName="p">{`Magento\\Framework\\GraphQl\\Exception`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Exception category`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQlAlreadyExistsException`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`graphql-already-exists`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thrown when data already exists`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQlAuthenticationException`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`graphql-authentication`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thrown when an authentication fails`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQlAuthorizationException`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`graphql-authorization`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thrown when an authorization error occurs`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQlInputException`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`graphql-input`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thrown when a query contains invalid input`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQlNoSuchEntityException`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`graphql-no-such-entity`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thrown when an expected resource doesn't exist`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      